import Vue from 'vue';
import VueRouter from 'vue-router';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { sync } from 'vuex-router-sync';
import App from './App';
import configRouter from './config/router';
import store from './vuex/store';
import vuetify from './config/vuetify';
import AuthKC, { authKeycloak } from './config/authKeycloak';
import AuthID, { authIDMagalu } from './config/authIdMagalu';
import i18n from './config/i18n';
import interceptors from './config/interceptors';
import plugins from './config/plugins';

// Forçando o jQuery global
window.jQuery = require("jquery"); // eslint-disable-line
window.$ = window.jQuery; // eslint-disable-line
window.$logger = console;

Vue.config.devtools = true;

plugins(Vue, VueRouter);
interceptors(Vue);

Vue.config.productionTip = false;

Vue.config.ignoredElements = [ // CHANGE
  'angular-gauge-chart',
  'bar-chart-3d',
  'clustered-chart',
  'column-chart',
  'data-grid',
  'line-chart',
  'lined-bar-chart',
  'pie-chart',
  'sbx-dashboard',
];

let aplicacaoInicializada = false;

function iniciarAplicacao(authenticated) {
  if (aplicacaoInicializada) {
    console.warn('Tentativa de criar a aplicação mais de uma vez.');
    return;
  }
  aplicacaoInicializada = true;

  const router = configRouter(VueRouter);
  sync(store, router);

  const i18nData = i18n(Vue, []);
  i18nData.locale = 'pt-br';

  router.onReady(() => {
    if (authenticated) {
      if (router.currentRoute.path === '/' || router.currentRoute.path === '/silentCheckSso') {
        router.replace({ name: 'inicio' });
      }
    } else if (router.currentRoute.path !== '/') {
      router.replace('/');
    }
  });

  new Vue({
    router,
    store,
    vuetify,
    i18n: i18nData,
    render: (h) => h(App),
    created() {
    },
  }).$mount('#app');
}

function loginIdMagalu() {
  console.log('Tentativa de autenticação em ID Magalu...');
  authIDMagalu.init()
    .then(async (authenticated) => {
      // Caso 1: Já autenticado com ID Magalu (por exemplo, token de atualização válido)
      if (authenticated) {
        console.log('Autenticado em ID Magalu com sucesso.');
        Vue.use(AuthID);
        authIDMagalu.setTokenInSession();
        authIDMagalu.createInterceptors();
        iniciarAplicacao(true);
        return;
      }

      // Caso 2: Este é um retorno de chamada de redirecionamento do IDP
      if (window.location.href.includes('code=')) {
        console.log('Tratamento de callback de redirecionamento do ID Magalu...');
        await authIDMagalu.getClientIDMagalu().handleRedirectCallback();
        if (authIDMagalu.getClientIDMagalu().isAuthenticated()) {
          console.log('Autenticado em ID Magalu com sucesso.');
          Vue.use(AuthID);
          authIDMagalu.setTokenInSession();
          authIDMagalu.createInterceptors();
          iniciarAplicacao(true);
        } else {
          console.warn('Usuário não autenticado em ID Magalu.');
          iniciarAplicacao(false);
        }
        return;
      }

      // Caso 3: Não autenticado e não é um retorno de chamada, o fallback final.
      console.log('Usuário do ID Magalu não autenticado.');
      authIDMagalu.removerDadosIdMagalu();
      iniciarAplicacao(false);
    })
    .catch((err) => {
      console.error('Erro fatal durante inicialização do ID Magalu: ', err);
      // Se o segundo método falhar catastroficamente, ainda acionaremos o fallback final.
      authIDMagalu.removerDadosIdMagalu();
      iniciarAplicacao(false);
    });
}

console.log('Iniciando processo de autenticação...');
authKeycloak.init()
  .then((authenticated) => {
    if (authenticated) {
      // Sucesso! O usuário do Keycloak está conectado.
      console.log('Autenticação Keycloak bem-sucedida.');
      Vue.use(AuthKC);
      authKeycloak.createInterceptors();
      iniciarAplicacao(true);
    } else {
      // O Keycloak não está logado, prossiga para o próximo método na cadeia.
      console.log('Usuário do Keycloak não autenticado. Tentar autenticar pelo ID Magalu.');
      loginIdMagalu();
    }
  })
  .catch((err) => {
    // O Keycloak falhou ao inicializar (por exemplo, o servidor está inativo).
    // Prossiga para o próximo método na cadeia.
    console.error('Falha na inicialização do Keycloak: ', err);
    console.log('Tentar autenticar pelo ID Magalu.');
    loginIdMagalu();
  });
